import { getSection } from "./sections";

export function updateMountainScene () {
  // wait until images have loaded
  if (!window.jmAppState.mountainSceneLoaded) return;
  const mountainSceneData = getSection('intro');
  const windowHeight = window.jmAppState.windowHeight;
  const windowWidth = window.jmAppState.windowHeight;
  const windowAspectRatio = windowWidth / windowHeight;
  const onScreenPortion = mountainSceneData.onScreenPortion;
  const offScreen = onScreenPortion <= 0;
  const renderCacheKey = window.jmAppState.renderKey;

  // Kill if janky
  const kill = window.jmAppState.killParralax;

  // Don't bother if we already rendered at this scroll position or if this element is off screen
  if (!kill && (renderCacheKey === window.jmAppState.mountainScene.lastRenderedCacheKey || offScreen)) {
    return;
  } else {
    window.jmAppState.mountainScene.lastRenderedCacheKey = renderCacheKey;
  }

  // Work out how much to shift scene. Don't shift at all if killing
  const shiftFactor = kill ? 0 : 1 - onScreenPortion;
  // Adjust colours (sooner than position shift)
  const colourShiftFactor = Math.min(shiftFactor * 2, 1);
  // Magnify position shift if scene is cropped vertically
  const svgAspectRatio = 1.0232;
  const posShiftFactor = (windowAspectRatio > svgAspectRatio) ? svgAspectRatio * shiftFactor / windowAspectRatio : shiftFactor;

  // Shift the planes and adjust colours. Don't make things fully opaque or transparent for iOS Safari performance
  const safeOpacity = (opacity) => Math.max(Math.min(.999, opacity), .001);
  for (let plane of Object.values(window.jmAppState.mountainScene.planes)) {
    const shift = posShiftFactor * plane.shift;
    const scale = plane.shift > .3 ? shift / 2 + 1 : 1; // Only scale from midground and forward
    const transform = `translate(0, ${-shift * 100}%) scale(${scale})`;
    plane.scene.style.transform = transform;
    if (plane.haze) {
      plane.haze.style.opacity = safeOpacity(1 - colourShiftFactor);
    }
  }
  // Squish the haze
  window.jmAppState.mountainScene.haze.style.transform = `scaleY(${1 - shiftFactor})`;
  // Shift the logo
  const logoShift = posShiftFactor * window.jmAppState.mountainScene.logoShift;
  const logoMinScale = 0;
  const logoScale = 1 - (shiftFactor * (1 - logoMinScale));
  window.jmAppState.mountainScene.logo.style.transform = `translate(0, ${-logoShift * 100}%) scale(${logoScale})`;
  window.jmAppState.mountainScene.logo.style.opacity = logoScale;
  // Fade out the buttons
  window.jmAppState.mountainScene.buttons.style.transform = `translate(0, ${-logoShift * 100}%)`;
  window.jmAppState.mountainScene.buttons.style.opacity = Math.max(0, 1 - (shiftFactor * 6));
};

// Start intro animation once required assets have loaded
export function initMountainScene () {
  // Init image objects
  if (!window.jmAppState.mountainScene.preloadImages) {
    window.jmAppState.mountainScene.preloadImages = window.jmAppState.mountainScene.preloadImageUrls.map((src) => {
      const img = new Image();
      img.src = src;
      return img;
    });
  }
  for (let image of window.jmAppState.mountainScene.preloadImages) {
    const complete = image.complete;
    if (!complete) {
      // Check again in a little bit
      window.setTimeout(initMountainScene, 300);
      return;
    }
  }
  const mountainSceneSection = getSection('intro').element;
  mountainSceneSection.classList.add("loaded");
  // When the mountains have finished moving we'll assume the intro animation is finished
  const animationEl = mountainSceneSection.querySelector('#bgInner');
  const introAnimationEnd = () => {
    mountainSceneSection.classList.add("introPlayed");
    animationEl.removeEventListener('animationend', introAnimationEnd);
  };
  animationEl.addEventListener('animationend', introAnimationEnd);

  // set flag to start parallax function
  window.jmAppState.mountainSceneLoaded = true;
}